import styled from 'styled-components';

export const AnalyticsStyled = styled.div`
  .disabled {
    opacity: 0.6;
  }
  .icon-average-rate {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background-color: #eff8ff;
  }

  .icon-average-total {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #0000000f;
  }

  .wrap-data-total-count {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    .custom-card {
      width: 120px;
    }
    @media screen and (max-width: 450px) {
      & > span {
        width: 100%;
        .custom-card {
          width: 100%;
          .custom-card-content {
            & > div {
              align-items: center;
              justify-content: center;
              .mr-16.icon-average-total {
                margin-right: 0;
              }
              & b {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }

  .h-full .Polaris-ShadowBevel {
    height: 100%;
  }
`;
